import { parseISO } from 'date-fns';

import { ISODate } from '@reckon-web/date-picker';

import { SearchJobsQueryVariables } from '../data/useSearchJobs';
import { SearchJobsWithTasksQueryVariables } from '../data/useSearchJobsWithTasks';
import { SearchTasksQueryVariables } from '../data/useSearchTasks';
import { SearchTasksWithJobQueryVariables } from '../data/useSearchTasksWithJob';

import { safeAddDays } from './date-utils';

export const parseSearchJobsVariables = (
  variables: SearchJobsQueryVariables | SearchJobsWithTasksQueryVariables,
  localDateToTenantToUtc: (
    localDate: Date | ISODate | null | undefined
  ) => Date | null | undefined
) => {
  if (!variables) {
    return variables;
  }

  return {
    ...variables,
    // due date is stored as midnight in the tenant timezone (as utc)
    // so we need to convert to tenant timezone when querying
    dueDateBegin:
      (variables.dueDateBegin &&
        localDateToTenantToUtc(variables.dueDateBegin)) ||
      null,
    dueDateEnd:
      ((variables.dueDateEnd || variables.dueDateBegin) &&
        safeAddDays(
          localDateToTenantToUtc(
            variables.dueDateEnd || variables.dueDateBegin
          ) as Date,
          1
        )) ||
      null,
    // start date is stored as midnight in the tenant timezone (as utc)
    // so we need to convert to tenant timezone when querying
    startDateBegin:
      (variables.startDateBegin &&
        localDateToTenantToUtc(variables.startDateBegin)) ||
      null,
    startDateEnd:
      ((variables.startDateEnd || variables.startDateBegin) &&
        safeAddDays(
          localDateToTenantToUtc(
            variables.startDateEnd || variables.startDateBegin
          ) as Date,
          1
        )) ||
      null,
    // closed date is just a point in time (in utc) so we can send the browser midnight (as utc)
    closedDateBegin:
      (variables.closedDateBegin && parseISO(variables.closedDateBegin)) ||
      null,
    closedDateEnd:
      ((variables.closedDateEnd || variables.closedDateBegin) &&
        safeAddDays(
          parseISO(
            variables.closedDateEnd || variables.closedDateBegin
          ) as Date,
          1
        )) ||
      null,
    // completed date is just a point in time (in utc) so we can send the browser midnight (as utc)
    completedDateBegin:
      (variables.completedDateBegin &&
        parseISO(variables.completedDateBegin)) ||
      null,
    completedDateEnd:
      ((variables.completedDateEnd || variables.completedDateBegin) &&
        safeAddDays(
          parseISO(
            variables.completedDateEnd || variables.completedDateBegin
          ) as Date,
          1
        )) ||
      null,
  };
};

export const parseSearchTasksVariables = (
  variables: SearchTasksQueryVariables | SearchTasksWithJobQueryVariables,
  localDateToTenantToUtc: (
    localDate: Date | ISODate | null | undefined
  ) => Date | null | undefined
) => {
  if (!variables) {
    return variables;
  }

  return {
    ...variables,
    // due date is stored as midnight in the tenant timezone (as utc)
    // so we need to convert to tenant timezone when querying
    dueDateBegin:
      (variables.dueDateBegin &&
        localDateToTenantToUtc(variables.dueDateBegin)) ||
      null,
    dueDateEnd:
      ((variables.dueDateEnd || variables.dueDateBegin) &&
        safeAddDays(
          localDateToTenantToUtc(
            variables.dueDateEnd || variables.dueDateBegin
          ) as Date,
          1
        )) ||
      null,
    // completed date is just a point in time (in utc) so we can send the browser midnight (as utc)
    completedDateBegin:
      (variables.completedDateBegin &&
        parseISO(variables.completedDateBegin)) ||
      null,
    completedDateEnd:
      ((variables.completedDateEnd || variables.completedDateBegin) &&
        safeAddDays(
          parseISO(variables.completedDateEnd || variables.completedDateBegin),
          1
        )) ||
      null,
  };
};
